<template>
  <div class="winding-section">
    <accordion-panel
      class="avoid-break"
      :collapsed.sync="collapsed"
      :id="`winding${windingId}-section`"
    >
      <template #title>
        <strong>
          {{ $t('general.winding') }} {{ windingId }}
        </strong>
      </template>
      <s-loader
        v-if="loading"
        id="loader"
        class="my-5"
        size="lg"
      />
      <b-row
        v-else-if="data && !loading"
        class="winding-section__sections"
      >
        <b-col
          class="px-2"
          cols="12"
          lg="4"
        >
          <isolation-remaining-useful-life
            :data="data.isolationLifetimeRemaining"
          />
        </b-col>
        <b-col
          class="px-2"
          cols="12"
          lg="4"
        >
          <acceleration-factor
            :data="data.accelerationFactor"
          />
        </b-col>
        <b-col
          class="px-2"
          cols="12"
          lg="4"
        >
          <auxiliary-information
            :data="data.auxiliaryInformation"
            :installation-time-zone="installationTimeZone"
          />
        </b-col>
      </b-row>
      <s-empty-list
        v-else
        id="empty-list"
        class="py-5"
      />
    </accordion-panel>
  </div>
</template>

<script>
import AccordionPanel from '@/components/AccordionPanel';
import IsolationRemainingUsefulLife from './IsolationRemainingUsefulLife';
import AccelerationFactor from './AccelerationFactor';
import AuxiliaryInformation from './AuxiliaryInformation';

export default {
  name: 'WindingSection',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    windingId: {
      type: Number,
      default: 1,
    },
    installationTimeZone: {
      type: String,
      default: '',
    },
  },
  components: {
    AccordionPanel,
    IsolationRemainingUsefulLife,
    AccelerationFactor,
    AuxiliaryInformation,
  },
  data: () => ({
    collapsed: false,
  }),
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/mobile-first"

  .winding-section
    margin-top: 15px
    &__sections > div
      min-height: 200px
      width: 100%
      display: flex
      flex: 1
    ::v-deep .accordion-panel
      box-shadow: none
      &__title-container
        display: flex
        align-items: center
      &__header
        padding: 3px 15px !important
  .manage-fonts_16px, .manage-fonts_18px
    .winding-section__sections > div
      +media-max-md
        min-height: 270px
</style>
